import { Avatar, Typography } from "@callcenter/design-system"
import { useUnit } from "effector-react"
import { buildUserInitials } from "@callcenter/helpers"
import { $userService } from "@callcenter/effector-services"

import { userAccountModel } from "../../models"
import { UserAccountFormHeaderSkeleton } from "../../components"

import styles from "./user-account-form-header.module.pcss"

export const UserAccountFormHeader = () => {
  const isLoading = useUnit(userAccountModel.$isPageLoading)
  const userInfo = useUnit($userService.$userSettings)

  if (isLoading) {
    return (
      <div className={styles.headerWrapper}>
        <UserAccountFormHeaderSkeleton />
      </div>
    )
  }

  return (
    <div className={styles.headerWrapper}>
      <Avatar size="L" initials={buildUserInitials(userInfo.name)} />
      <div className={styles.userInfoBlockWrapper}>
        <Typography.Body1 weight="medium" className={styles.userInfoContainer}>
          {userInfo.name}
        </Typography.Body1>
        <Typography.Body2 className={styles.userInfoContainer}>{userInfo.email}</Typography.Body2>
      </div>
    </div>
  )
}
